import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@mui/material';

import ErrorMessage from './ErrorMessage';
import InfoMessage from './InfoMessage';
import { actions, selectors } from '../store/dux/alerts-dux';

export function Alerts() {
  const dispatch = useDispatch();
  const error = useSelector(selectors.error);
  const info = useSelector(selectors.info);

  if (error) {
    return (
      <Box
        data-testid="errors"
        sx={{
          pointerEvents: 'none',
          position: 'absolute',
          padding: 3,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'flex-end',
          zIndex: 1500,
        }}
      >
        <ErrorMessage close={closeError} error={error} />
      </Box>
    );
  }

  if (info) {
    return <InfoMessage close={closeInfo} info={info} />;
  }

  function closeError() {
    dispatch(actions.showError(null));
  }

  function closeInfo() {
    dispatch(actions.showInfo(null));
  }
}
